import { BaseModuleObject } from "../frameworkObjects/BaseModuleObject";

export class ModuleObject extends BaseModuleObject {

	isAccessible(childBirthdate){
		return true
	}
}
